import React from "react";

const PluginActionResponsePane = () => {
  return <div />;
};

export default PluginActionResponsePane;
